// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// COOKIE SCHEMA
/////////////////////////////////////////

export const CookieSchema = z.object({
  name: z.string(),
  value: z.string(),
  path: z.string().nullable(),
  domain: z.string().nullable(),
  expires: z.string().nullable(),
  httpOnly: z.boolean().nullable(),
  secure: z.boolean().nullable(),
  sameSite: z.string().nullable(),
  priority: z.string().nullable(),
})

export type Cookie = z.infer<typeof CookieSchema>

export default CookieSchema;
